<script setup lang="ts">
import {computed, ref} from "vue";
import {MoneyFormatFilter} from "@/models/filters/money";
import {CurrencyCode, frontofficeCurrencyFilter} from "@/models/core/currency";
import {
  filterCryptoInfoDataByCurrency,
  useUserCryptoAccountsInfoMod,
} from "@/views/pages/finance/accounts/accountspage";

const props = defineProps({
  currency: {
    type: String,
    required: true,
  },
  address: {
    type: String,
    required: false,
    default: null
  },
  showAll: {
    type: Boolean,
    required: false,
    default: false
  },
})

const currency = computed(() => {
  return props.currency
})
const address = computed(() => {
  return props.address
})

const cryptoInfo = useUserCryptoAccountsInfoMod();

const cryptoInfoCurrencyData = computed(() => {
  if (!cryptoInfo.data?.value) return null;

  return filterCryptoInfoDataByCurrency( cryptoInfo.data?.value, currency.value as CurrencyCode );
})

const hasIncomingData = computed(() => {
  return cryptoInfoCurrencyData.value
    && cryptoInfoCurrencyData.value?.incomingInfo
    && cryptoInfoCurrencyData.value?.incomingInfo?.length > 0;
})

const showAll = computed(() => {
  return props.showAll;
})

const incomingTransactions = computed(() => {
  return cryptoInfoCurrencyData.value.incomingInfo ? cryptoInfoCurrencyData.value?.incomingInfo.filter((details) => {
    return (currency.value === details.currency)
    && (showAll.value || (address.value && (details.wallet === address.value)));
  }) : [];
})

</script>

<template>
  <div v-if="hasIncomingData && incomingTransactions.length > 0"
       class="bitcoin-incoming-transactions">
    <template v-if="hasIncomingData">
      <div v-for="transaction in incomingTransactions" class="bitcoin-incoming-transaction">
        <div class="bit-icon">⤷</div>
        <div class="bit-amount">
          <i18n path="waiting_for_amount">
            <template #amount>
              <strong>{{ MoneyFormatFilter(transaction.amount, transaction.currency) }}</strong>
            </template>
            <template #cur>
              <strong>{{ frontofficeCurrencyFilter(transaction.currency) }}</strong>
            </template>
          </i18n>
        </div>
        <div class="bit-confirmations">
          <a :href="transaction.blockchaininfoUrl"
             :title="$t('tx_details_on_url', {url: 'blockchain.info'})"
             target="_blank">
            {{ $tc('confirmations', transaction.confirmations) }}
          </a></div>
      </div>
    </template>
  </div>
</template>

<style scoped lang="less">
.bitcoin-incoming-transactions {

}
</style>

<i18n>
{
  "en": {
    "waiting_for_amount": "Waiting for: {amount} {cur}",
    "tx_details_on_url": "Transaction details on {url}",
    "confirmations": "no confirmations | one confirmation | {count} confirmations",
    "apple": "no apples | one apple | {count} apples"
  },
  "ru": {
    "waiting_for_amount": "В ожидании: {amount} {cur}",
    "tx_details_on_url": "Детали транзакции на {url}",
    "confirmations": "нет подтверждений | одно подтверждение | {count} подтверждения | {count} подтвержений",
    "apple": "нет яблок | одно яблоко | {count} яблока | {count} яблок"
  }
}
</i18n>
